const pathNamePrefix = '/campaign/vnext/';

export const getPathNameOfSubPageItem = subPageItem =>
  `${pathNamePrefix}${subPageItem.route}`;
